import { FC } from 'react';

import { Typography } from '@mui/material';

import { ILabelCss, TLegendLabelRenderer } from '../../types';

import styles from './LegendLabel.module.scss';

interface ILegendLabelProps {
  title: string;
  percentage: number;
  render?: TLegendLabelRenderer;
}

export const LegendLabel: FC<ILegendLabelProps> = ({ title, percentage, render }) => {
  if (render) {
    return render(title, percentage, styles as unknown as ILabelCss);
  }

  return (
    <Typography variant="h4" className={styles['root']}>
      {title} <span className={styles.percentage}>— {percentage}%</span>
    </Typography>
  );
};
